export function formatPrice(priceStr: string) {
  return `£${Number.parseFloat(priceStr).toFixed(2)}`;
}
